import React from "react";

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

// Permanent safety net for the admin dashboard. If a render error escapes the
// dashboard (e.g. a single malformed record), it is caught here and shown as a
// recoverable message instead of unmounting React and blanking the screen.
export default class AdminErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("Admin dashboard crashed:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="adm-p-24 adm-center" style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 14,
            background: "#f9fafb",
            fontFamily: "system-ui, -apple-system, sans-serif",
          }}
        >
          <h2 style={{ margin: 0, color: "#111827" }}>
            Something went wrong loading the dashboard
          </h2>
          <p style={{ margin: 0, color: "#6b7280", maxWidth: 440, lineHeight: 1.5 }}>
            A data issue stopped this page from rendering. It has been logged for
            the team. Try reloading — if it keeps happening, let an engineer know.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="adm-mt-6 adm-semibold adm-pointer" style={{
              padding: "10px 22px",
              borderRadius: 8,
              border: "none",
              background: "#2563eb",
              color: "#fff",
              fontSize: "0.9rem",
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
